<script setup lang="ts">
import { default as PDivider } from 'primevue/divider'
import { computed } from 'vue'

const props = defineProps<{
  title?: string
  hasFooter?: boolean
  withoutContent?: boolean
  withoutDivider?: boolean
  padding?: 'small' | 'medium' | 'large'
  gap?: number
  size?: 'auto'
}>()

const paddingClasses = computed(() => {
  switch (props.padding) {
    case 'small':
      return 'p-4'
    case 'medium':
      return 'p-6'
    case 'large':
      return 'p-8'
    default:
      return 'p-6'
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'auto':
      return 'w-auto h-auto'
    default:
      return 'h-full'
  }
})

const gapClass = computed(() => {
  if (props.gap) {
    return `gap-${props.gap}`
  }

  return 'gap-4'
})
</script>

<template>
  <div
    class="border-primary-100 bg-surface-0 flex flex-col overflow-hidden rounded-xl border"
    :class="[paddingClasses, sizeClasses]"
  >
    <h4
      v-if="title"
      class="mb-4 line-clamp-2 h-16 overflow-hidden text-lg font-medium"
      :title="title"
    >
      {{ title }}
    </h4>
    <slot v-if="!title" name="header" />

    <div v-if="!withoutContent" class="mb-auto grid grid-cols-1" :class="[gapClass]">
      <slot name="content" />
    </div>

    <template v-if="hasFooter">
      <PDivider v-if="!withoutDivider" class="border-bo-brand-secondary" />

      <slot name="footer" />
    </template>
  </div>
</template>
